import page from '../shared/qualify/page';

export default ({ path, actionPipe }) => page({ path, actionPipe, scenario: 'Qualify' });



// WEBPACK FOOTER //
// ./src/products/qualify/index.js